<template>
	<NormalHeaderLayout header="Latest security news">
		<RSSList></RSSList>
	</NormalHeaderLayout>
</template>

<script>
import RSSList from '../components/overview/rss/RSSList';
import NormalHeaderLayout from '../components/layout/NormalHeaderLayout';

export default {
	mounted() {
		this.$store.dispatch('rssStore/fetchRSS');
	},
	components: {
		RSSList,
		NormalHeaderLayout
	}
};
</script>

<style lang="scss" scoped>
</style>
